import { createTRPCContext } from '@trpc/tanstack-react-query';

// Import the AppRouter type from our type definitions
import type { AppRouter } from '../types/trpc';

// Create the React Query hooks for tRPC v11
export const trpc = createTRPCContext<AppRouter>();

// Export the provider and hooks
export const { TRPCProvider, useTRPC, useTRPCClient } = trpc;
